import React, { ReactElement } from 'react';
import { IntlShape, useIntl } from 'react-intl';
import { WorkDateTypeDTO } from '../../../../api/core/models';
import { Actions, MultiInputControls } from '../../../components/form/MultiInput/MultiInputControls';
import { getDefaultWorkDateType } from '../../../../Settings/emptyModels';
import { ValidationResult } from '../../../../util/validation/interfaces';


import { Panel } from '../layout/Panel';
import { LabelledCalendar } from '../../../components/form/LabelledCalendar';
import { InputGroup } from '../layout/InputGroup';
import { CheckPermissionFunction } from '../../../../Auth/components/PermissionGate';
import { LabelledDropdown } from '../../../components/form/LabelledDropdown';
import { getVocabularyOptions } from '../../../../Vocabulary/util';


interface DateTypeProps {
  title: string;
  dates: WorkDateTypeDTO[];
  onChange: (dates: WorkDateTypeDTO[]) => void;
  pubtypeGroup: string;
  validation: ValidationResult;
  checkPermission: CheckPermissionFunction;
  autoFocus: boolean;
}

export function WorkDateTypes(props: DateTypeProps): ReactElement {
  const intl: IntlShape = useIntl();
  return (
    <Panel title={props.title} toggleable={true} collapsed={true}>
      <MultiInputControls<WorkDateTypeDTO>
        canEdit={props.checkPermission().canWrite}
        lines={props.dates || []}
        onChange={(dates: WorkDateTypeDTO[]): void => props.onChange(dates)}
        addNew={(rows: WorkDateTypeDTO[]): number => rows.push(getDefaultWorkDateType())}
        renderLines={(dateType: WorkDateTypeDTO, onLineChange: (data: WorkDateTypeDTO) => void, actions: Actions, idx: number): ReactElement => (
          <InputGroup
            delete={{
              action: actions.delete,
              disabled: !props.checkPermission().canWrite,
            }}
          >
            <LabelledCalendar
              label={`${props.title}.attr.date`}
              autoFocus={props.autoFocus}
              validation={props.validation?.children[idx]?.fields?.date}
              onChange={(date: Date): void => onLineChange({...dateType, date})}
              value={dateType.date ? dateType.date : undefined}
              permissions={props.checkPermission('date')}
              id={`workDate_${idx}_date`}
            />
            <LabelledDropdown
              id={`workDate_${idx}_type`}
              onChange={(type: string): void => onLineChange({...dateType, type})}
              label={`${props.title}.attr.type`}
              permissions={props.checkPermission('type')}
              validation={props.validation?.children[idx]?.fields?.type}
              options={getVocabularyOptions(intl.locale, 'date_types_list', props.pubtypeGroup)}
              value={dateType.type || null}
            />
          </InputGroup>
        )}
      />
    </Panel>
  );
}
